// extracted by mini-css-extract-plugin
export var item = "cartItem-module--item--NCQAo";
export var xremove = "cartItem-module--xremove--CKXh1";
export var image = "cartItem-module--image--s7WgP";
export var desc = "cartItem-module--desc--hprpk";
export var count = "cartItem-module--count--96Qu6";